/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .info-field_link[_ngcontent-%COMP%]   .info-head[_ngcontent-%COMP%]{float:left}[_nghost-%COMP%]   a.info-value[_ngcontent-%COMP%]{margin-left:4px;overflow:hidden;max-width:150px;white-space:nowrap;text-overflow:ellipsis;display:inline-block}[_nghost-%COMP%]   .info-field[_ngcontent-%COMP%]{display:flex;flex-direction:row!important;align-items:flex-start!important;justify-content:flex-start}[_nghost-%COMP%]   .info-field[_ngcontent-%COMP%]   .info-value[_ngcontent-%COMP%]{margin-left:4px;flex:1;white-space:pre-line}"];
export { styles as styles };
